import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PageComponent, Redirection } from '@tytapp/common';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-communication-preference',
  templateUrl: './communication-preference.component.html',
  styleUrls: ['./communication-preference.component.scss']
})
export class CommunicationPreferenceComponent extends PageComponent {
  private redirection = inject(Redirection);
  private route = inject(ActivatedRoute);

  async init() {
    this.route.paramMap.subscribe(params => {
      if (params.has('email'))
        this.redirection.go(`${environment.urls.app}/settings/messaging?e=${encodeURIComponent(params.get('email'))}&id=${encodeURIComponent(params.get('profile_id'))}`);
      else
        this.redirection.go(`${environment.urls.app}/settings/messaging`);
    });
  }
}
